// extracted by mini-css-extract-plugin
export default {"container":"style_container__mE4qC","titleSection":"style_titleSection__8gQDR"};